import React from 'react'
import HeaderCompo from "../../component/Header";

const CPTSettings = () => {
  return (
    <>
    <HeaderCompo initialColor={'#000833'} />
    <div className='text-black'>
      CPT Setting
    </div>
    </>
  )
}

export default CPTSettings
